'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

export default function BreadcrumbPageViewReporter() {
  const pathname = usePathname();

  useEffect(() => {
    if (!pathname) return;

    fetch('/api/espresso/breadcrumb/page-view', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: pathname }),
      keepalive: true,
    }).catch(() => undefined);
  }, [pathname]);

  return null;
}
